import Vue from 'vue'
import mapManager from './mapManager.vue'
import axios from 'axios'
import { Icon } from 'leaflet'
import "leaflet/dist/leaflet.css"
import filter from 'lodash/filter';
import get from 'lodash/get';

// this part resolve an issue where the markers would not appear
delete Icon.Default.prototype._getIconUrl;

Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')
});

new Vue({
  render: h => h(mapManager),
  data() {
    return {
      places: false,
      filteredPlaces: null,
      filters: {},
      loaded: false,
      endpoint: null,
      contentText: {
        'commerce': 'Commerce',
        'mixite': 'Mixité urbaine',
        'projet': 'Projets',
        'actif': 'Actifs',
        'prochainement': 'Prochainement',
        'title': 'Les lieux',
        'placeholder': 'Filtrer par mot clé'
      }
    }
  },
  methods: {
    setFilter(key, value) {
      this.filters[key] = value

      this.filteredPlaces = this.getFilteredPlaces()
    },
    getFilteredPlaces() {

      if (Object.values(this.filters).length === 0) {
        return this.places
      }

      return filter(this.places.data, place => {
        let keepCount = 0;
        Object.keys(this.filters).forEach(key => {
          const filterValue = this.filters[key];
          const placeValue = get(place, key, false);

          if (!filterValue) {
            keepCount++;
            return;
          }

          if (Array.isArray(filterValue)) {
            keepCount = filterValue.indexOf(placeValue) > -1 ? keepCount + 1 : keepCount;
          }

          if (key === 'fullText') {
            const placeTitle = place.title.rendered
            const placeCity = place.acf.place_city
            if (placeTitle.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1 || placeCity.toLowerCase().indexOf(filterValue.toLowerCase()) !== -1) {
              keepCount = keepCount + 1
            }
          }
        });

        return keepCount === Object.keys(this.filters).length
      });
    }
  },
  mounted() {
    const theEndpoint = this.endpoint ? this.endpoint : 'https://frey.staging.maecia.com/wp-json/wp/v2/lieu?per_page=100';
    axios
      .get(theEndpoint)
      .then(response => (this.places = response))
      .then(() => (this.loaded = true))
  },
  created() {
    this.endpoint = document.getElementById('app').getAttribute('data-endpoint')
    this.contentText = document.getElementById('app').getAttribute('data-contentText') ? JSON.parse(document.getElementById('app').getAttribute('data-contentText')) : this.contentText
  }
}).$mount('#app');
